import { action, makeAutoObservable, observable } from 'mobx'

export class ObjectStore<T> {
  data:Map<string, T>
  storeType: string = 'ObjectStore'
  constructor () {
    this.data = new Map<string, T>();
    makeAutoObservable(this, {
      data: observable,
      setValue: action,
      clear: action,
      getValue: action,
      putValue: action
    })
  }

  setValue (key:string, value: T) {
    this.data.set(key, value);
  }

  putValue (data : any) {
    this.data = data
  }

  clear () {
    this.data.clear();
  }

  getValue (key: string): T {
    const rs = this.data.get(key);
    if (!rs) {
      throw new Error(`${key} is not found`)
    }
    return rs;
  }
}
